import clsx from 'clsx';
import type * as React from 'react';

import type { BlockProps } from '@gitbook/slate-react';

import { usePlainMarkdownStyle } from '../usePlainMarkdownStyle';
import { BasicBlockWrapper } from './BasicBlockWrapper';

/*
 * Basic renderer for a paragraph block.
 */
export function BasicBlockParagraph(props: BlockProps): React.ReactElement {
    const { children, ...rest } = props;

    const { textStyle } = usePlainMarkdownStyle();

    return (
        <BasicBlockWrapper className={clsx(textStyle, 'text-content-paragraph')} tag="p" {...rest}>
            {children}
        </BasicBlockWrapper>
    );
}
